import Login from "../../components/user/login";

const LoginPage = () => {
  return <Login></Login>;
};

export default LoginPage;
